<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.file-code-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Notification templates') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="save">
          <div class="p-4">
            <strong>{{ $t('Placeholders') }}</strong>
            <div class="px-4 rounded-md mb-5 py-5 bg-gray-100 sm:p-6">
              <p>
                {tracking_id} : <small class="text-sm">{{ $t('Repair order tracking id') }}</small>
              </p>
              <p>
                {customer_name} : <small class="text-sm">{{ $t('Customer name being used for repair order booking') }}</small>
              </p>
              <p>
                {tracking_link} : <small class="text-sm">{{ $t('Repair order tracking link for customer can tracking status') }}</small>
              </p>
              <p>
                {order_link} : <small class="text-sm">{{ $t('Repair order inovice print link') }}</small>
              </p>
              <p>
                {dispatch_link} : <small class="text-sm">{{ $t('Dispatch card link for customer can dispatch by using card') }}</small>
              </p>
              <p>
                {order_date} : <small class="text-sm">{{ $t('Repair order created date') }}</small>
              </p>
              <p>
                {company_name} : <small class="text-sm">{{ $t('Company or shop name') }}</small>
              </p>
              <p>
                {agent_name} : <small class="text-sm">{{ $t('Repair order assinged to technication name') }}</small>
              </p>
            </div>

            <strong>{{ $t('On order booking') }}</strong>
            <div class="px-4 rounded-md mb-5 py-5 bg-gray-100 sm:p-6">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="template_order_created_subject">{{ $t('Mail subject') }}</label>
                  <input type="text" class="form-input" v-model="template_order_created.subject" />
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_created_mail_content">{{ $t('Mail content') }}</label>
                  <div class="pt-1">
                    <input-wysiwyg
                      :plugins="{ images: false, quickReply: false }"
                      id="template_order_created_mail_content"
                      v-model="template_order_created.mail_content"
                    />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_created_sms_content">{{ $t('SMS content') }}</label>
                  <input type="text" class="form-input" v-model="template_order_created.sms_content" />
                </div>
              </div>
            </div>
            <strong>{{ $t('On order updated') }}</strong>
            <div class="px-4 rounded-md mb-5 py-5 bg-gray-100 sm:p-6">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="template_order_updated_subject">{{ $t('Mail subject') }}</label>
                  <input type="text" class="form-input" v-model="template_order_updated.subject" />
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_updated_mail_content">{{ $t('Mail content') }}</label>
                  <div class="pt-1">
                    <input-wysiwyg
                      :plugins="{ images: false, quickReply: false }"
                      id="template_order_updated_mail_content"
                      v-model="template_order_updated.mail_content"
                    />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_updated_sms_content">{{ $t('SMS content') }}</label>
                  <input type="text" class="form-input" v-model="template_order_updated.sms_content" />
                </div>
              </div>
            </div>
            <strong>{{ $t('On order assigning') }}</strong>
            <div class="px-4 rounded-md mb-5 py-5 bg-gray-100 sm:p-6">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="template_order_assigned_subject">{{ $t('Mail subject') }}</label>
                  <input type="text" class="form-input" v-model="template_order_assigned.subject" />
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_assigned_mail_content">{{ $t('Mail content') }}</label>
                  <div class="pt-1">
                    <input-wysiwyg
                      :plugins="{ images: false, quickReply: false }"
                      id="template_order_assigned_mail_content"
                      v-model="template_order_assigned.mail_content"
                    />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_assigned_sms_content">{{ $t('SMS content') }}</label>
                  <input type="text" class="form-input" v-model="template_order_assigned.sms_content" />
                </div>
              </div>
            </div>
            <strong>{{ $t('On order booking admin alert') }}</strong>
            <div class="px-4 rounded-md mb-5 py-5 bg-gray-100 sm:p-6">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="template_order_alert_to_admin_subject">{{ $t('Mail subject') }}</label>
                  <input type="text" class="form-input" v-model="template_order_alert_to_admin.subject" />
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_alert_to_admin_mail_content">{{ $t('Mail content') }}</label>
                  <div class="pt-1">
                    <input-wysiwyg
                      :plugins="{ images: false, quickReply: false }"
                      id="template_order_alert_to_admin_mail_content"
                      v-model="template_order_alert_to_admin.mail_content"
                    />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_alert_to_admin_sms_content">{{ $t('SMS content') }}</label>
                  <input type="text" class="form-input" v-model="template_order_alert_to_admin.sms_content" />
                </div>
              </div>
            </div>
            <strong>{{ $t('On order booking dispatch information') }}</strong>
            <div class="px-4 rounded-md mb-5 py-5 bg-gray-100 sm:p-6">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="template_order_dispatch_subject">{{ $t('Mail subject') }}</label>
                  <input type="text" class="form-input" v-model="template_order_dispatch.subject" />
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_dispatch_mail_content">{{ $t('Mail content') }}</label>
                  <div class="pt-1">
                    <input-wysiwyg
                      :plugins="{ images: false, quickReply: false }"
                      id="template_order_dispatch_mail_content"
                      v-model="template_order_dispatch.mail_content"
                    />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="template_order_dispatch_sms_content">{{ $t('SMS content') }}</label>
                  <input type="text" class="form-input" v-model="template_order_dispatch.sms_content" />
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'terms',
  metaInfo() {
    return {
      title: this.$i18n.t('Terms and conditions'),
    };
  },
  data() {
    return {
      loading: true,
      template_order_created: {},
      template_order_updated: {},
      template_order_assigned: {},
      template_order_alert_to_admin: {},
      template_order_dispatch: {},
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      axios
        .get(route('settings.get.templates'))
        .then((response) => {
          this.template_order_created = response.data.template_order_created ?? {};
          this.template_order_updated = response.data.template_order_updated ?? {};
          this.template_order_assigned = response.data.template_order_assigned ?? {};
          this.template_order_alert_to_admin = response.data.template_order_alert_to_admin ?? {};
          this.template_order_dispatch = response.data.template_order_dispatch ?? {};
          this.loading = false;
        })
        .catch(function () {
          this.$router.push('/admin/settings');
        });
    },
    save() {
      this.loading = true;
      axios
        .post(route('settings.set.templates'), {
          template_order_created: this.template_order_created,
          template_order_updated: this.template_order_updated,
          template_order_assigned: this.template_order_assigned,
          template_order_alert_to_admin: this.template_order_alert_to_admin,
          template_order_dispatch: this.template_order_dispatch,
        })
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
